import * as React from "react";

export function CategoryTitle({ children }) {
  const y = -8;
  const x = 16;
  const fontSize = 36;
  return (
    <>
      <text
        aria-hidden
        x={x}
        y={y}
        fontSize={fontSize}
        fill="hsl(0deg 0% 95%)"
        stroke="hsl(0deg 0% 95%)"
        strokeWidth={2}
      >
        {children}
      </text>
      <text x={x} y={y} fontSize={fontSize}>
        {children}
      </text>
    </>
  );
}
